module.exports = __webpack_public_path__ + "static/media/preview.9a01e944.png";